var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.226562,
    width: 20,
    height: 20,
    rx: 10,
    fill: "#0A77A9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.37695 12.8574C9.3724 12.6934 9.37012 12.5703 9.37012 12.4883C9.37012 12.0052 9.43848 11.5882 9.5752 11.2373C9.67546 10.973 9.83724 10.7064 10.0605 10.4375C10.2246 10.2415 10.5186 9.95671 10.9424 9.58301C11.3708 9.20475 11.6488 8.90397 11.7764 8.68066C11.904 8.45736 11.9678 8.21354 11.9678 7.94922C11.9678 7.4707 11.7809 7.05143 11.4072 6.69141C11.0335 6.32682 10.5755 6.14453 10.0332 6.14453C9.50911 6.14453 9.07161 6.30859 8.7207 6.63672C8.36979 6.96484 8.13965 7.47754 8.03027 8.1748L6.76562 8.02441C6.87956 7.09017 7.2168 6.37467 7.77734 5.87793C8.34245 5.38118 9.08757 5.13281 10.0127 5.13281C10.9925 5.13281 11.7741 5.39941 12.3574 5.93262C12.9408 6.46582 13.2324 7.11068 13.2324 7.86719C13.2324 8.30469 13.1299 8.70801 12.9248 9.07715C12.7197 9.44629 12.3187 9.89518 11.7217 10.4238C11.3206 10.7793 11.0586 11.0413 10.9355 11.21C10.8125 11.3786 10.7214 11.5723 10.6621 11.791C10.6029 12.0098 10.5687 12.3652 10.5596 12.8574H9.37695ZM9.30176 15.3252V13.9238H10.7031V15.3252H9.30176Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.26f98c97ba2af50983b0c2498d09b4f8.svg";
export { ForwardRef as ReactComponent };